import { useState } from 'react';
import { OutlineCheckIcon, OutlineDocumentDuplicateIcon } from '@tempmee/react-icons';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IReferralLinkProps {
  link: string;
  style?: React.CSSProperties;
}

export const ReferralLink = ({ link, style }: IReferralLinkProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setIsCopied(true);
  };

  return (
    <Column style={style}>
      <Typography as="span" bold color={colors.neutral[600]} style={{ marginLeft: 4 }}>
        Copy and Share Your Link
      </Typography>
      <Row gap={5} pt={3}>
        <input
          className="input-field"
          style={{ margin: 0, width: '380px', borderRadius: 10 }}
          type="text"
          value={link}
          disabled={true}
        />

        <button
          type="button"
          className="button"
          style={{
            backgroundColor: colors.primary[500],
            alignItems: 'center',
            display: 'flex',
            alignSelf: 'center',
            margin: 0,
            paddingBlock: 3,
          }}
          onClick={() => {
            handleCopy();
          }}
        >
          <OutlineDocumentDuplicateIcon />
          <Typography as="span" bold size="body_large" color={colors.shades[0]} style={{ marginLeft: 5 }}>
            Copy
          </Typography>
        </button>
      </Row>
      <Row gap={1} align="center" style={{ height: 32, marginLeft: 2 }}>
        {isCopied && (
          <>
            <OutlineCheckIcon size={24} color={colors.success[400]} />
            <Typography as="span">
              Your referral link has been <Typography as="span" bold>copied</Typography>!
            </Typography>
          </>
        )}
      </Row>
    </Column>
  );
};
